import React from 'react';
import { connect } from 'react-redux';
import { MenuItemLink, useResourceDefinitions } from 'react-admin';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SubMenu from '@mui/material/Collapse'; // Usa SubMenu o Collapse para la funcionalidad de submenu
import { decrypt } from '../../../../services/security/encryptorHandlerSecurity';
import UserHelper from '../../../../helpers/UserHelper';

const styles = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        height: '100%',
    },
    submenuHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
};

const DashboardMenuLink = ({ onClick }) => (
    <MenuItem component="a" href="/dashboard" onClick={onClick}>
        <ArrowRightAltIcon />
        Dashboard
    </MenuItem>
);

const CustomMenu = ({ hasDashboard, resources, onMenuTap, logout }) => {
    const { resources: resourceDefinitions } = useResourceDefinitions();
    const v = UserHelper.validateLocal();
    const user = typeof v === 'string' && v !== null ? JSON.parse(decrypt(localStorage.getItem(v))) : null;

    const [openMenus, setOpenMenus] = React.useState({});

    const handleToggle = (menuName) => {
        setOpenMenus((prevState) => ({
            ...prevState,
            [menuName]: !prevState[menuName],
        }));
    };

    return (
        <div style={styles.main}>
            {hasDashboard && <DashboardMenuLink onClick={onMenuTap} />}
            {resources
                .filter(r => (r.list || r.subcategorie) && !r.parentCategorie && (!r.private || (r.private && user && user.info.typeId === 2)))
                .map(resource => {
                    const subcategories = resourceDefinitions.filter(item => item.parentCategorie === resource.name);

                    return (
                        <div key={resource.name}>
                            {resource.initSection && <Divider />}
                            {subcategories.length > 0 ? (
                                <div>
                                    <MenuItem onClick={() => handleToggle(resource.name)} style={styles.submenuHeader}>
                                        <div style={{ display: 'flex', alignItems: 'center'}}>
                                            <ArrowDropDownIcon />
                                            {resource.options.label || resource.name}
                                        </div>
                                    </MenuItem>
                                    <SubMenu in={openMenus[resource.name]}>
                                        {subcategories.map(children => (
                                            <MenuItemLink
                                                key={children.name}
                                                to={`/${children.name}`}
                                                primaryText={children.options.label || children.name}
                                                leftIcon={<children.icon />}
                                                onClick={onMenuTap}
                                            />
                                        ))}
                                    </SubMenu>
                                </div>
                            ) : (
                                <MenuItemLink
                                    key={resource.name}
                                    to={`/${resource.name}`}
                                    primaryText={resource.options.label || resource.name}
                                    leftIcon={<resource.icon />}
                                    onClick={onMenuTap}
                                />
                            )}
                            {resource.finishSection && <Divider />}
                        </div>
                    )
                })}
            {logout}
        </div>
    );
};

const mapStateToProps = state => ({
    resources: state.admin.resources,
})

export default connect(mapStateToProps)(CustomMenu);
